import { z } from 'zod/v4-mini';

export const professionSchema = z.literal(['doctor', 'nurse']);
export type Profession = z.infer<typeof professionSchema>;

export const ProfessionsTranslations = {
  doctor: 'profile.doctor',
  nurse: 'profile.nurse',
} as const satisfies Record<Profession, string>;
